import * as React from 'react';
import TextCompareComponent from './TextCompareComponent';
import TwoLanguageTextArea from './TwoLanguageTextArea';
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";
import HATEOASClient from 'src/services/HATEOASClient';
import {ResourceListOfOptionDto} from 'src/services/Client';

interface TwoLanguageCompareTextAreaProps extends IVirtualizedTableCellComponentProps {
    globalSearch?: string;
    isNewGrid?: boolean;
    client?: HATEOASClient;
    postOptions?: ResourceListOfOptionDto;
    pslAiGeneratedLongtext?: boolean;
    pslAiGeneratedShorttext?:boolean;
    aiGeneratedUsp?:boolean;
    aiGeneratedFooter?:boolean;
    longTextSuggestion?:boolean;
    apiMethod?: (client: HATEOASClient, postOptions: ResourceListOfOptionDto) => {execute: (payload: any) => Promise<any>};
    grammarApiMethod?: (client: HATEOASClient, postOptions: ResourceListOfOptionDto) => {execute: (payload: any) => Promise<any>};
    suggestionApiMethod?: (client: HATEOASClient, postOptions: ResourceListOfOptionDto) => {execute: (payload: any) => Promise<any>};
    objectId?:number;
}

export const TwoLanguageCompareTextArea: React.StatelessComponent<TwoLanguageCompareTextAreaProps> = (props: TwoLanguageCompareTextAreaProps) => {

    return (
        <div className="display--flex">
            {!props.uglyMode &&
                <div className="textCompare">
                    <TextCompareComponent
                        value={props.value}
                        onChange={props.onChange}
                        isSpecificPSL={props.isSpecificPSL}
                        maintainedTextsIconColor={props.maintainedTextsIconColor}
                        inEditMode={props.inEditMode ? props.inEditMode : false}
                        readOnly={props.readOnly}
                        t={props.t}
                    />
                </div>
            }
            <div style={{'width': '-webkit-fill-available'}}>
                <TwoLanguageTextArea
                    {...props}
                />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Table/components/twoLanguage/TwoLanguageCompareTextArea.tsx